import React from 'react';

import FlowchartNodeToolbar, {FlowchartNodeToolbarButton} from './FlowchartNodeToolbar';

export interface SimpleFlowchartNodeToolbarProps {
  isLocked?: boolean;
  onNodeEdit?: () => void;
  onNodeDelete?: () => void;
  /**
   * When provided, the delete button is rendered as disabled with this string shown in a tooltip
   * on hover. Use this to communicate why a node can't be deleted (e.g., tasks already exist).
   * Has no effect when {@link onNodeDelete} is not provided.
   */
  deleteDisabledTooltip?: string;
}

export default function SimpleFlowchartNodeToolbar({
  isLocked,
  onNodeEdit,
  onNodeDelete,
  deleteDisabledTooltip,
}: SimpleFlowchartNodeToolbarProps): JSX.Element | null {
  if (!onNodeEdit && !onNodeDelete) {
    return null;
  }

  const buttons: Array<FlowchartNodeToolbarButton> = [];

  if (onNodeEdit) {
    buttons.push({
      icon: isLocked ? 'eye' : 'edit', // When locked, the sidepanel should still open but in read only mode
      onClick: onNodeEdit,
      elementName: 'editNodeButton',
    });
  }
  if (onNodeDelete) {
    buttons.push({
      icon: 'trash-can',
      onClick: onNodeDelete,
      elementName: 'deleteNodeButton',
      disabled: deleteDisabledTooltip != null,
      tooltip: deleteDisabledTooltip,
    });
  }

  return <FlowchartNodeToolbar buttons={buttons} />;
}
